import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Calendar } from 'lucide-react';
import type { NicheConfig } from '../../niches/types';
import LeadCaptureForm from './LeadCaptureForm';

interface Props {
  config: NicheConfig;
}

export default function NicheCTA({ config }: Props) {
  const { cta, slug } = config;
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="booking" className="px-6 py-20 md:py-28 max-w-7xl mx-auto w-full">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="relative overflow-hidden rounded-3xl border border-stroke bg-gradient-to-br from-accent-from/10 via-surface to-bg p-8 md:p-14"
      >
        <div className="flex items-center justify-center mb-6">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-text-primary text-bg">
            <Calendar className="w-5 h-5" />
          </div>
        </div>

        <LeadCaptureForm
          sourceTag={slug}
          title={cta.title}
          description={cta.description}
        />
      </motion.div>
    </section>
  );
}
